export function inviteCodeFromURL(address) {
  try {
    const url = new URL(address);
    if (url.searchParams.has('solo')) return '';
    const code = (url.searchParams.get('room') || url.pathname.match(/^\/room\/([a-f0-9]{8})\/?$/i)?.[1] || '').toUpperCase();
    return /^[A-F0-9]{8}$/.test(code) ? code : '';
  } catch { return ''; }
}

export function setupJoinMenu(options) {
  if (new URL(location.href).searchParams.has('gameNight') && parent !== window) return;
  const names = options.nameInput || '#nickname,#name';
  const codes = options.codeInput || '#room-code,#roomCode,#roomcode,#code,#room,#join-room,input[name="code"]';
  const hostSelector = '#create,#create-btn,#createButton,#create-form button[type="submit"],#createForm button[type="submit"],#create-form button:not([type]),#createForm button:not([type]),[data-enter="create"],[data-action="create"],[data-do="create"]';
  const practiceSelector = '#practice,#practice-btn,#practiceButton,#solo,[data-enter="practice"],[data-action="practice"],[data-action="solo"],[data-action="soloStart"],[data-do="solo"],[data-command="practice"]';
  let activeName, activeInvite, activeLanguage, opened = false, controls, opener, host, joinButton, joiningByCode = false;
  const text = (en, fr, sr) => document.documentElement.lang.startsWith('fr') ? fr : document.documentElement.lang.startsWith('sr') ? sr : en;
  const hide = (element, hidden) => {
    if (!element) return;
    element.hidden = hidden;
    if (hidden) element.style.setProperty('display', 'none', 'important');
    else if (element.style.getPropertyPriority('display') === 'important') element.style.removeProperty('display');
  };
  function validCode() {
    const input = document.querySelector(codes);
    if (!input) return Boolean(inviteCodeFromURL(location.href)) || options.joinOpener === true;
    const value = input.value.trim();
    input.value = (inviteCodeFromURL(value) || value).toUpperCase();
    const valid = /^[A-F0-9]{8}$/.test(input.value);
    input.setCustomValidity(valid ? '' : text('Enter the 8-character room code.', 'Entrez le code de 8 caractères.', 'Unesi kod od 8 znakova.'));
    if (!valid) { input.reportValidity(); input.focus(); }
    return valid;
  }
  function joinFields(show) {
    const name = document.querySelector(names), input = document.querySelector(codes);
    if (!input) return;
    input.disabled = Boolean(activeInvite) || !show;
    input.autocomplete = 'off'; input.spellcheck = false;
    input.style.minWidth = '0'; input.style.maxWidth = '100%';
    input.setAttribute('aria-label', text('Room code', 'Code de la table', 'Kod stola'));
    let group;
    for (let node = input.parentElement; node && node !== document.body; node = node.parentElement) {
      if (node.matches('.join-row,.joinrow,.join-code,.join,#join-fields,#joinForm,#join-form') && !node.contains(name) && !node.contains(host)) { group = node; break; }
    }
    if (group) {
      hide(group, !show);
      if (show) { group.style.flexWrap = 'wrap'; group.style.minWidth = '0'; input.style.flex = '1 1 140px'; }
    }
    hide(input.closest('label') || input, !show);
    document.querySelectorAll('label[for]').forEach(label => { if (label.htmlFor === input.id) hide(label, !show); });
    hide(joinButton, !show);
    if (joinButton && show) joinButton.textContent = text('Join table', 'Rejoindre', 'Pridruži se');
  }
  function prepare() {
    const name = document.querySelector(names), invite = options.inviteCode ? options.inviteCode() : inviteCodeFromURL(location.href);
    if (!name) return;
    if (name === activeName && invite === activeInvite) {
      if (!invite && activeLanguage !== document.documentElement.lang && host && opener) {
        activeLanguage = document.documentElement.lang;
        host.textContent = text('Host a game', 'Créer une partie', 'Napravi partiju');
        opener.textContent = text('Join a game', 'Rejoindre une partie', 'Pridruži se partiji');
        if (opened && !options.joinOpener) joinFields(true);
      }
      return;
    }
    activeLanguage = document.documentElement.lang;
    activeName = name; activeInvite = invite; opened = false;
    name.required = true; name.autocomplete = 'nickname';
    if (invite && options.skipInvites) return;
    joinButton = options.join ? document.querySelector(invite ? options.join : options.menuJoin || options.join) : null;
    host = document.querySelector(options.host || hostSelector);
    const submit = name.closest('form')?.querySelector('button[type="submit"],button:not([type])');
    if (!host && submit !== joinButton) host = submit;
    if (!invite && options.submitByCode && host) {
      joinButton = document.createElement('button'); joinButton.type = 'button';
      joinButton.textContent = text('Join table', 'Rejoindre', 'Pridruži se');
      document.querySelector(codes)?.after(joinButton);
      joinButton.onclick = () => { joiningByCode = true; host.click(); joiningByCode = false; };
    }
    if (!joinButton) return;
    if (invite) {
      document.querySelectorAll(hostSelector + ',' + practiceSelector + ',#show-join').forEach(button => { if (button !== joinButton) hide(button, true); });
      const input = document.querySelector(codes);
      if (input) { input.value = invite; input.disabled = true; }
      joinFields(true);
      return;
    }
    if (!host) return;
    controls = document.createElement('div'); controls.className = 'direct-entry-actions';
    host.before(controls); controls.append(host);
    controls.parentElement.style.flexWrap = 'wrap';
    host.classList.add('direct-entry-host');
    host.formNoValidate = true;
    host.textContent = text('Host a game', 'Créer une partie', 'Napravi partiju');
    host.removeAttribute('data-en'); host.removeAttribute('data-fr'); host.removeAttribute('data-t');
    hide(host, false);
    opener = options.joinOpener ? joinButton : document.createElement('button');
    if (!options.joinOpener) {
      opener.type = 'button';
      opener.className = (joinButton.className || host.className).split(/\s+/).filter(c => !/^(primary|accent|confirm|wide|direct-entry-host)$/.test(c)).join(' ');
      opener.setAttribute('aria-expanded', 'false');
      opener.onclick = () => {
        opened = !opened; opener.setAttribute('aria-expanded', String(opened)); joinFields(opened);
        if (opened) document.querySelector(codes)?.focus();
      };
    }
    opener.classList.add('direct-entry-join');
    opener.textContent = text('Join a game', 'Rejoindre une partie', 'Pridruži se partiji');
    controls.append(opener); hide(opener, false);
    document.querySelectorAll(options.hideJoinOpener || '#show-join').forEach(button => { if (button !== opener) hide(button, true); });
    if (options.submitByCode) {
      const input = document.querySelector(codes), area = document.createElement('div');
      area.className = 'join-row'; controls.after(area);
      const label = [...document.querySelectorAll('label[for]')].find(label => label.htmlFor === input.id);
      if (label) area.append(label);
      area.append(input, joinButton);
    }
    const container = name.closest('form,.entry,.join-box,.join-panel,.menu-form') || name.parentElement;
    container.querySelectorAll('.divider').forEach(divider => hide(divider, true));
    if (!options.joinOpener) joinFields(false);
    for (let node = controls; node && node !== document.body; node = node.parentElement) node.style.minWidth = '0';
  }
  document.addEventListener('input', event => { if (event.target.matches(codes)) event.target.setCustomValidity(''); }, true);
  document.addEventListener('click', event => {
    if (!activeName?.isConnected) return;
    const button = event.target.closest('button');
    if (button === host && !activeInvite && !activeName.reportValidity()) { event.preventDefault(); event.stopImmediatePropagation(); return; }
    if (button === joinButton && !options.joinOpener && !activeName.reportValidity()) { event.preventDefault(); event.stopImmediatePropagation(); return; }
    if (button === host && options.submitByCode && !joiningByCode && !activeInvite) { const input = document.querySelector(codes); if (input) input.value = ''; }
    if (button === joinButton && (!options.joinOpener || activeInvite) && !validCode()) { event.preventDefault(); event.stopImmediatePropagation(); }
  }, true);
  document.addEventListener('submit', event => {
    if (!activeName?.isConnected || activeInvite || options.joinOpener) return;
    const input = document.querySelector(codes);
    if (!input || !event.target.contains(input) || event.submitter === host) return;
    if (event.target.contains(activeName) && !opened) {
      event.preventDefault(); event.stopImmediatePropagation(); host?.click(); return;
    }
    if (!validCode()) { event.preventDefault(); event.stopImmediatePropagation(); return; }
    if (event.submitter !== joinButton) { event.preventDefault(); event.stopImmediatePropagation(); joinButton?.click(); }
  }, true);
  document.addEventListener('keydown', event => {
    if (!activeName?.isConnected || activeInvite) return;
    if (event.key === 'Escape' && opened) { opened = false; opener.setAttribute('aria-expanded', 'false'); joinFields(false); opener.focus(); }
    if (event.key === 'Enter' && !options.joinOpener && event.target.matches(names + ',' + codes)) {
      event.preventDefault(); event.stopImmediatePropagation();
      if (opened && validCode()) joinButton?.click();
      else if (!opened) host?.click();
    }
  }, true);
  const style = document.createElement('style');
  style.textContent = '.direct-entry-actions{display:grid!important;grid-template-columns:minmax(0,1fr);gap:8px;width:100%;max-width:100%;flex:1 0 100%;box-sizing:border-box}.direct-entry-actions>button{display:block!important;width:100%;max-width:100%;min-height:48px!important;box-sizing:border-box;white-space:normal}.direct-entry-host{font-weight:800}.direct-entry-join{font-weight:600}.direct-entry-actions button:focus-visible{outline:3px solid currentColor;outline-offset:3px}@media(max-width:600px){body:has(.direct-entry-actions) header nav{flex-wrap:wrap;min-width:0;max-width:100%}}';
  document.head.append(style);
  new MutationObserver(prepare).observe(document.documentElement, {childList:true,subtree:true,attributes:true,attributeFilter:['lang']});
  queueMicrotask(prepare);
}
